import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { updateCurrentPwd } from "../../config/config";

const PasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old Password is required"),
  newPassword: Yup.string().required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required("Confirm Password is required"),
});

const ChangePassword = () => {
  const [saveResult, setSaveResult] = useState(null);

  const handleChangePassword = async (values) => {
    try {
      const response = await updateCurrentPwd(values);
console.log(response.data)
      if (response.status === 200) {
        setSaveResult({ success: true, message: response.data.message });
      
      } else {
        setSaveResult({ success: false,  message: response.message});
      }
    } catch (error) {
        console.log("error,", error)
      setSaveResult({ success: false, message: "An error occurred while changing the password" });
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Change Password
      </Typography>
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={PasswordSchema}
        onSubmit={handleChangePassword}
      >
        {({ errors, touched }) => (
          <Form>
            <Box sx={{ marginBottom: 2 }}>
              <Field
                as={TextField}
                label="Old Password"
                name="oldPassword"
                type="password"
                fullWidth
                error={touched.oldPassword && Boolean(errors.oldPassword)}
                helperText={touched.oldPassword && errors.oldPassword}
              />
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Field
                as={TextField}
                label="New Password"
                name="newPassword"
                type="password"
                fullWidth
                error={touched.newPassword && Boolean(errors.newPassword)}
                helperText={touched.newPassword && errors.newPassword}
              />
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Field
                as={TextField}
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                fullWidth
                error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                helperText={touched.confirmPassword && errors.confirmPassword}
              />
            </Box>
            <Button variant="contained" color="primary" type="submit">
              Change Password
            </Button>
            {saveResult && (
              <Alert
                severity={saveResult.success ? "success" : "error"}
                sx={{ marginTop: 2 }}
              >
                {saveResult.message}
              </Alert>
            )}
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ChangePassword;
